import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAPI } from '../../API';
import { useAppDispatch, useAppState } from '../../Store';
import { useTranslation } from '../../Translation';
import SidebarNav from '../../Components/SidebarNav/SidebarNav';
import SettingSidebarNav from '../../Components/SidebarNav/SettingSidebarNav';
import useAuthenticated from '../Dashboard/useAuthenticated';
import Badge from '../../Components/Badge';
import { TextInput } from '../../Components/Inputs/TextInput';
import { Button } from "../../Components/Buttons";
import { boldWordInText } from '../../Utils';
import { ActionTypes } from '../../Store/Stores/User';
export default function Shopify() {


    const { translate, language, setLanguage } = useTranslation();
    const api = useAPI();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const appState = useAppState();
    const { user } = appState;
    const [twilioAccountSid, setTwilioAccountSid] = useState(user?.twilio_account_sid);

    const { isAuthenticated, pathAfterLogin } = useAuthenticated();

    const updateTwilioAccountSid = async () => {
        const userUpdated = {...user, twilio_account_sid: twilioAccountSid};
        const response = await api.updateUser(userUpdated);
        dispatch({
            type: ActionTypes.SET_USER,
            payload: userUpdated
        });
        console.log(response);
    }

    return (
        <div className="flex min-h-full w-full">
            <SidebarNav currentPage="settings" contentPadding={false}>
                <div className='flex-1 flex-row h-full w-full'>
                    <SettingSidebarNav currentPage="twilio" />
                    <div className='flex-1 flex flex-col ml-24 md:ml-72'>
                        <div className='flex flex-col p-2 md:p-4 lg:p-6 w-full'>
                            <h3 className='text-2xl font-bold'>{translate('setting.twilio.twilio_connection')}</h3>
                            <p className='text-md text-gray-500 max-w-4xl'>{translate('setting.twilio.description')}</p>

                            <div className='flex flex-col mt-8'>
                                <div className='flex flex-col'>
                                    <h4 className='text-lg font-bold'>{translate('setting.twilio.how_it_work')}</h4>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl'>{translate('setting.twilio.how_it_work_description')}</p>
                                    <h4 className='text-lg font-bold mt-8'>{translate('setting.twilio.set_twilio_account_sid')}</h4>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl'>{boldWordInText(translate('setting.twilio.set_twilio_account_sid_description'), ['yourstore.myshopify.com', 'votreboutique.myshopify.com'])}</p>
                                    <div className='flex flex-row bg-gray-100 p-4 rounded-md mt-4 max-w-4xl items-end justify-between gap-8'>
                                        <div className='flex flex-col w-52'>
                                            <TextInput 
                                            label={translate('setting.twilio.twilio_account_sid')} 
                                            placeholder={translate('setting.twilio.twilio_account_sid_placeholder')}
                                            value={twilioAccountSid} 
                                            onChange={(e) => {
                                                setTwilioAccountSid(e.target.value);
                                            }} />
                                        </div>
                                        <div className='flex flex-col gap-2'>
                                        <Button onClick={updateTwilioAccountSid}>
                                            {translate('save')}
                                        </Button>
                                        </div>
                                       
                                       
                                    </div>
                                </div>
                                <div className='flex flex-col mt-8'>
                                    <h4 className='text-lg font-bold'>{translate('setting.twilio.configure_twilio_webhook')}</h4>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl mt-4'>{translate('setting.twilio.configure_twilio_webhook_description')}</p>
                                    <ul className="list-disc list-inside mt-2 ml-4 space-y-2">
                                        <li>{boldWordInText(translate('setting.twilio.configure_twilio_webhook_description_step_1'), ['Develop', 'Messaging', 'Services', 'Webhooks', 'Paramètres'])}</li>
                                        <li>{boldWordInText(translate('setting.twilio.configure_twilio_webhook_description_step_2'), ['Create Webhook', 'Créer un webhook'])}</li>
                                        <li>{boldWordInText(translate('setting.twilio.configure_twilio_webhook_description_step_3'), ['Integration', 'Intégration'])}</li>
                                        <li>{boldWordInText(translate('setting.twilio.configure_twilio_webhook_description_step_4'), ['Send a webhook', 'Envoyer un webhook'])}</li>
                                        <li>{boldWordInText(translate('setting.twilio.configure_twilio_webhook_description_step_5'), ['https://api.hoodleapp.com/api/event/twilio/track'])}</li>
                                        <li>{boldWordInText(translate('setting.twilio.configure_twilio_webhook_description_step_6'), ['Save', 'Enregistrer'])}</li>
                                    </ul>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl mt-4'>{translate('setting.twilio.configure_twilio_webhook_description_end')}</p>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                
            </SidebarNav>
        </div>

    );
}